/**
 * Formatting for a digest week label — ONE implementation, because the two that
 * existed disagreed.
 *
 * WHY UTC IS LOAD-BEARING. A week is stored as a naive-UTC Monday and served as a UTC
 * instant (see the timezone conventions: the DB is naive-UTC, the API emits UTC-aware).
 * Handing that to `new Date(iso).toLocaleDateString()` renders it in the VIEWER's zone,
 * so every week west of UTC comes out a day early — a digest for the week of Aug 10
 * labelled "Aug 9", and a span reading "Jul 26 → Aug 9" against a picker that says
 * "Aug 10". Forcing `timeZone: 'UTC'` makes the label the week it actually is.
 *
 * The `length === 10` branch is the other half: `/digests` serves full instants, but the
 * selected-week state and the `?week=` parameter are bare `YYYY-MM-DD`. Those parse as
 * UTC midnight already, but only in engines that follow the date-only rule — appending
 * the zone explicitly is what makes both inputs take the same path.
 */
export function weekLabel(iso: string): string {
  return new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

/** A topic's run as one string, or '' when either end is missing. */
export function weekSpan(first?: string | null, last?: string | null): string {
  return first && last ? `${weekLabel(first)} → ${weekLabel(last)}` : '';
}
